import axios from "axios";
import { getAuthTokens } from "../../utils/cookieUtils";
import {
  normalizeInventoryList,
  normalizeInventoryRow,
  toApiStatus,
} from "./addeparInventoryUtils";

const endpoint = process.env.REACT_APP_REST_ENDPOINT;

const authHeaders = () => {
  const tokens = getAuthTokens() || {};
  const idToken = tokens.idToken;
  return {
    "Content-Type": "application/json",
    ...(idToken ? { Authorization: `Bearer ${idToken}` } : {}),
  };
};

export const fetchAddeparInventory = async () => {
  const options = {
    method: "GET",
    url: `${endpoint}addepar/inventory`,
    headers: authHeaders(),
  };

  let response = { success: false, data: [] };

  try {
    const res = await axios.request(options);
    const rawData = Array.isArray(res.data?.data)
      ? res.data.data
      : Array.isArray(res.data?.inventory)
        ? res.data.inventory
        : Array.isArray(res.data)
          ? res.data
          : [];

    response = {
      success: true,
      data: normalizeInventoryList(rawData),
    };
  } catch (error) {
    response.error = true;
    response.message =
      error?.response?.data?.message ||
      error?.message ||
      "Failed to load Addepar inventory";
    console.error(error);
  }

  return response;
};

export const updateAddeparInventoryStatus = async (
  addeparInventoryId,
  status
) => {
  const options = {
    method: "POST",
    url: `${endpoint}addepar/updateinventorystatus`,
    headers: authHeaders(),
    data: {
      addeparInventoryId,
      status: toApiStatus(status),
    },
  };

  let response = { success: false };

  try {
    const res = await axios.request(options);
    const inventory = res.data?.inventory
      ? normalizeInventoryRow(res.data.inventory)
      : null;
    response = {
      success: res.data?.success !== false,
      data: res.data,
      inventory,
      sma: res.data?.sma || null,
    };
  } catch (error) {
    response.error = true;
    response.message =
      error?.response?.data?.message ||
      error?.message ||
      "Failed to update inventory status";
    console.error(error);
  }

  return response;
};
